var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"fixed-header":"true"},scopedSlots:_vm._u([{key:"item[data.data[0][d]]",fn:function(ref){
var item = ref.item;
return [_c('div',{key:_vm.d},[_vm._v(_vm._s(_vm.d))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }